/**
 * Despite the name, this is NOT a list of application statuses.
 * It is a single integer enum value: None = 0, Denied = 1, ConditionallyApproved = 2, Both = 3.
 * Controls which status transitions require adverse action reasons.
 */
export enum AppStatusesToRequireAdverseActionReasons {
  None = 0,
  Denied = 1,
  ConditionallyApproved = 2,
  Both = 3
}
